import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-secondary-50/80 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Explore Shopping Categories
          </h2>
          <p className="text-foreground-600 text-base max-w-lg mx-auto">
            Browse our complete catalog of agent shopping categories. Every category links directly to the <strong>kaspreadsheet.com</strong> marketplace for instant access.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] bg-background-200 cursor-pointer"
            >
              <img
                src={cat.cardUrl}
                alt={`${cat.name} - CSSBuy Spreadsheet Shopping`}
                title={`${cat.name} - CSSBuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block px-3 py-1 bg-background-50/20 backdrop-blur-sm rounded-full text-xs text-background-50 mb-2">
                  Shop Now
                </span>
                <h3 className="text-base md:text-lg font-bold text-background-50">{cat.name}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}